var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"svgaContainer",class:_vm.className,style:(_vm.styleObj),attrs:{"id":_vm.svId}})}
var staticRenderFns = []

export { render, staticRenderFns }